module.exports = __webpack_public_path__ + "static/media/N1.d3f5d7a4.png";